import { useQuery } from 'react-query';
import { network } from 'services/network';
import { QueryKeys } from 'api/queryKeys';

const queryFn = (params: QueryParams) => {
    return network
        .post('api/bo/management/getCommonObjectsList', {
            objectsList: params.objectsList,
            projectId: params.projectId,
        })
        .then((response) => {
            return response.data;
        });
};

export const useQueryGetCommonResources = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getCommonResources', params],
        queryFn: () => queryFn(params),
        staleTime: 1000 * 60 * 5,
    });
};

export interface QueryParams {
    objectsList: (keyof QueryResponse)[];
    projectId?: number;
}

export type IUser = {
    firstName: string;
    id: null;
    lastName: string;
    userName: string;
    imageName: string;
};

export type ITags = {
    id: number;
    name: string;
};

export interface QueryResponse {
    users?: IUser[];
    tags?: ITags;
}
